import React from 'react';
import { ProjectDocsStats } from './ProjectDocsStats';
import { ProjectDocsRecent } from './ProjectDocsRecent';
import { ProjectDocsTemplates } from './ProjectDocsTemplates';

export function ProjectDocsSidebar() {
  return (
    <div className="space-y-6">
      {/* Thống kê tài liệu */}
      <ProjectDocsStats />

      {/* Tài liệu mới cập nhật */}
      <ProjectDocsRecent />

      {/* Mẫu tài liệu */}
      <ProjectDocsTemplates />
    </div>
  );
}
